import React, { useState, useRef, useEffect } from 'react';
import Calendar from '../calendar/calendar';
import styles from './calendarDropdown.module.css';
interface CalendarDropdownProps {
    onDateSelect: (date: Date | [Date, Date] | null) => void;
    allowRangeSelection?: boolean;
    buttonText?: string;
    initialDateRange?: [Date, Date];
}

const CalendarDropdown: React.FC<CalendarDropdownProps> = ({
                                                               onDateSelect,
                                                               allowRangeSelection = false,
                                                               buttonText = 'Выбрать дату',
                                                               initialDateRange
                                                           }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedDate, setSelectedDate] = useState<Date | [Date, Date] | null>(initialDateRange || null);

    useEffect(() => {
        if (initialDateRange) {
            setSelectedDate(initialDateRange);
        }
    }, [initialDateRange]);

    const handleDateSelect = (date: Date | [Date, Date] | null) => {
        setSelectedDate(date);
        onDateSelect(date);  // Передаем выбранную дату в родительский компонент
        setIsOpen(false);
    };

    const toggleCalendar = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className={styles.calendarDropdown}>
            <button onClick={toggleCalendar} className={styles.dropdownButton}>
                {selectedDate
                    ? (Array.isArray(selectedDate)
                        ? `${selectedDate[0].toLocaleDateString()} - ${selectedDate[1].toLocaleDateString()}`
                        : selectedDate.toLocaleDateString())
                    : buttonText}
            </button>
            {isOpen && (
                <div className={styles.calendarContainer}>
                    <Calendar
                        onDateSelect={handleDateSelect}
                        allowRangeSelection={allowRangeSelection}
                        initialDateRange={Array.isArray(selectedDate) ? selectedDate : undefined}
                    />
                </div>
            )}
        </div>
    );
};

export default CalendarDropdown;